export class AssignerGroupDossier
{
    dueDate:String;
    username:String;
    taskIdList:string[];
}